import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import { CUSTOMER_WALLET_MODAL_MODE } from '../../constants';
import { customerWalletModalStore } from '../../store';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';

const CustomerWalletModalMode: FC = observer((): JSX.Element => {
  const { loading, isTopUpMode } = customerWalletModalStore;

  const selectMode = useCallback((mode: string | number | undefined) => {
    customerWalletModalStore.changeMode(mode as CUSTOMER_WALLET_MODAL_MODE);
  }, []);

  return (
    <div className="d-flex flex-row gap-40 mb-6">
      <Checkbox type="radio" value={isTopUpMode} label="top_up" name={CUSTOMER_WALLET_MODAL_MODE.TOP_UP} onClick={selectMode} disabled={loading} />
      <Checkbox
        type="radio"
        value={!isTopUpMode}
        label="correct"
        name={CUSTOMER_WALLET_MODAL_MODE.CORRECTION}
        onClick={selectMode}
        disabled={loading}
      />
    </div>
  );
});

export default CustomerWalletModalMode;
